<template>
    <th
        class="mds-data-table__header-cell"
        scope="col"
        v-bind="{...attrs, ...$attrs}"
        @click="safeAction"
    >
        <div
            class="mds-data-table__header-cell-inner"
            :class="[sortClass, alignClass]"
            :tabindex="action ? 1 : undefined"
            :role="action ? 'button' : ''"
        >
            <slot>{{ text }}</slot>
        </div>
    </th>
</template>
<script>
import { isDef, getCellWidth } from '@/utils/data-table';
import { noop } from '@/utils/misc';

const SORT_CLASSES = {
  [-1]: 'mds-data-table__header-cell-inner--selected-descending',
  0: '',
  1: 'mds-data-table__header-cell-inner--selected-ascending',
};

const ALIGN_CLASSES = {
  left: '',
  right: 'mds-data-table__header-cell--right',
};

export default {
  props: {
    width: { type: Number, default: NaN },
    action: { type: Function, default: undefined },
    text: { type: String, default: '' },
    align: { type: String, default: 'left' },
    sortDirection: { type: Number, default: NaN },
  },

  computed: {
    sortClass() {
      return SORT_CLASSES[this.sortDirection] || '';
    },
    alignClass() {
      return ALIGN_CLASSES[this.align] || '';
    },

    attrs() {
      const { width, sortDirection } = this;
      const isSortable = isDef(sortDirection);
      const attrs = {};

      if (isSortable) {
        if (sortDirection < 0) {
          attrs['aria-sort'] = 'descending';
        } else if (sortDirection > 0) {
          attrs['aria-sort'] = 'ascending';
        } else {
          attrs['aria-sort'] = 'none';
        }
      }

      if (width) {
        attrs.width = getCellWidth(width);
      }

      return attrs;
    },

    safeAction() {
      return this.action ? this.action : noop;
    },
  },
};
</script>
